/**
 * @param {Object} options:
 * @property {Object} stockWrapper - wrapper DOM element that we toggle the stock attr on
 * @property {String} stockWrapperAttr - the attr on the stockWrapper that is toggled with the stock value
 * @property {Object} atcButton - DOM element for the add to cart button
 * @property {String} oosAttr - attr on the atcButton that has the text for oos product
 * @property {String} inStockAttr - attr on the atcButton that has the text for the instock product
 * @property {String} unavailableAttr - attr on the atcButton that has the text for the unavailable product
 * 
 * @returns {Function(availablilityFlag{Boolean}, skipAttribute{Boolean})} (impure) function that takes the availabity and updates the stock display on the page
 */

const switchStockDisplay = (options) => ((availablilityFlag, skipAttribute) => {

  const purchasable = availablilityFlag === 'available' || availablilityFlag === 'pre-order' || availablilityFlag === 'low'

  const {stockWrapper, stockWrapperAttr, atcButton, oosAttr, inStockAttr, unavailableAttr, preOrderAttr} = options;

  atcButton.disabled = !purchasable;

  if (!skipAttribute) {
    stockWrapper.setAttribute(stockWrapperAttr, availablilityFlag)
  }
  
  if (availablilityFlag === 'pre-order') {
    atcButton.innerHTML = atcButton.getAttribute(preOrderAttr)
  } else if (availablilityFlag === 'available' || availablilityFlag === 'low') {
    atcButton.innerHTML = atcButton.getAttribute(inStockAttr)
  } else if (availablilityFlag === 'oos') {
    atcButton.innerHTML = atcButton.getAttribute(oosAttr)
  } else {
    atcButton.innerHTML = atcButton.getAttribute(unavailableAttr)
  }
})
export default switchStockDisplay